import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import LabStoreProduct from "../../views/Admin/LabStoreProduct";
import TitleWithDescription from "../Headers/TitleWithDescription";
import StepsNavButtons from "../Buttons/StepsNavButtons";
import OrganizationsAPI from "../../API/organizations.api";
import ModelVersionsAPI from "../../API/modelVersions.api";
import {
    PRODUCT_TYPES,
    SUBSCRIPTION_TYPES,
    CURRENCY_NAMES,
} from "../../utils/constants";
import SimpleNotification from "../Notifications/SimpleNotification";

const PreviewProduct = ({
    product,
    nextStep,
    prevStep,
    publishModel,
    selectedParameterVersion,
    manageSubsciptionsForm,
    bundleProducts,
    isBundle,
    // isNewVersion,
    previewMode,
}) => {
    const [previewProduct, setPreviewProduct] = useState({});
    const [parameterNames, setParameterNames] = useState([]);
    const [isPreview, setIsPreview] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        prepareProductForReview();
        selectedParameterVersion &&
            setParameterNames(
                selectedParameterVersion.map((version) => ({
                    label: version.label,
                    hidden: version.hidden,
                }))
            );
    }, []);

    useEffect(() => {
        if (!previewMode) setIsPreview(true);
    }, [previewMode]);

    const prepareProductForReview = async () => {
        const organization = await getOrganizationInfo();
        let parameterDetails = [];
        if (selectedParameterVersion) {
            const parameterVersionIds = selectedParameterVersion.map(
                (n) => n.value
            );
            parameterDetails = await getParametersDetails(parameterVersionIds);
        }
        setPreviewProduct({
            ...product,
            type: bundleProducts ? PRODUCT_TYPES.bundle : PRODUCT_TYPES.model,
            subscriptionPlans: getSubscriptionPlan(),
            hasTrial: manageSubsciptionsForm.hasTrial,
            trialDays: manageSubsciptionsForm.trialDays?.value,
            materialNames: bundleProducts
                ? [...product.materialName]
                : [product.materialName],
            numberOfDownloads: 0,
            publishedAt: new Date(),
            parameters: selectedParameterVersion ? parameterDetails : undefined,
            developedBy: {
                name: organization.name,
                image: organization.image,
                country: organization.country?.label,
            },
            bundleProducts: bundleProducts ? bundleProducts : undefined,
            supportedCountries: product?.supportedCountries?.map((country) => ({
                value: country.value,
                label: country.searchable,
                alpha2Code: country.code,
            })),
        });
    };

    const getSubscriptionPlan = () => {
        let mappedSubscriptionObject = {
            ...(manageSubsciptionsForm.choosenSubscriptionTypes
                .monthlySubscription && {
                monthlySubscriptionDollar: {
                    price: manageSubsciptionsForm.monthlySubscriptionDollar,
                    currencyName: CURRENCY_NAMES.dollar.toLowerCase(),
                    durationType: SUBSCRIPTION_TYPES.monthly,
                },
                monthlySubscriptionEuro: {
                    price: manageSubsciptionsForm.monthlySubscriptionEuro,
                    currencyName: CURRENCY_NAMES.euro.toLowerCase(),
                    durationType: SUBSCRIPTION_TYPES.monthly,
                },
            }),
            ...(manageSubsciptionsForm.choosenSubscriptionTypes
                .annualSubscription && {
                annualSubscriptionDollar: {
                    price: manageSubsciptionsForm.annualSubscriptionDollar,
                    currencyName: CURRENCY_NAMES.dollar.toLowerCase(),
                    durationType: SUBSCRIPTION_TYPES.annual,
                },
                annualSubscriptionEuro: {
                    price: manageSubsciptionsForm.annualSubscriptionEuro,
                    currencyName: CURRENCY_NAMES.euro.toLowerCase(),
                    durationType: SUBSCRIPTION_TYPES.annual,
                },
            }),
        };
        let plan = [];

        for (var key in mappedSubscriptionObject) {
            plan.push({
                price: mappedSubscriptionObject[key].price,
                durationType: mappedSubscriptionObject[key].durationType,
                currencyName: mappedSubscriptionObject[key].currencyName,
            });
        }

        return plan;
    };

    const getOrganizationInfo = async () => {
        return OrganizationsAPI.getOrganizationInfo();
    };

    const getParametersDetails = async (ids) => {
        return ModelVersionsAPI.getReview(ids);
    };

    const handleNextPage = () => {
        publishModel();
        nextStep();
    };

    return (
        <>
            <div className="steps step1 show">
                <TitleWithDescription
                    title={t("publishModelStep4")}
                    description={t(
                        isBundle
                            ? "publishBundleStep4Paragraph"
                            : "publishModelStep4Paragraph"
                    )}
                />
                <div className="card-table shadow flex flex-col">
                    {product?.forceUpgrade?.booleanValue && (
                        <SimpleNotification
                            type="warnTriangle"
                            message={t("forceUpgradePreview")}
                        />
                    )}
                    <LabStoreProduct
                        product={previewProduct}
                        previewParameterName={parameterNames}
                        isPreview={isPreview}
                        previewMode={previewMode}
                    />
                </div>
            </div>
            <StepsNavButtons
                back={{ action: prevStep }}
                next={{
                    action: handleNextPage,
                    label: t("submit"),
                }}
            />
        </>
    );
};

export default PreviewProduct;
